const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const highlight = (
    haystack,
    needle,
    styling = "font-bold text-primary"
) => {
    if (!needle) {
        return haystack;
    }
    const searchRegex = new RegExp(`(${escapeRegExp(needle)})`, "gi");
    return haystack.replace(searchRegex, `<span class="${styling}">$1</span>`);
};
